import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialIncentivoImpiantoState } from './incentivo_impianto.state';
import { getIncentivoImpianto } from './incentivo_impianto.utility';
import { GetIncentivoImpiantoGQL } from '../../_graphql/generated';

export const IncentivoImpiantoStore = signalStore(
  { providedIn: 'root' },
  withState(initialIncentivoImpiantoState),
  withProps(() => ({
    getter: inject(GetIncentivoImpiantoGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getIncentivoImpianto(injector, store, getter),
  })),
);
